// extracted by mini-css-extract-plugin
module.exports = {"link-tags-container":"subcategories-section_link-tags-container__wQpu8"};